import React, { useEffect, useCallback, useState } from "react";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Button,
  FormHelperText,
} from "@mui/material";
import { Delete as DeleteIcon, Send as SendIcon } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Field } from "react-final-form";

import { Select, TextField } from "../common/Fields";
import { Content } from "../layout";
import {
  getUser,
  submitUser,
  updateUser,
  deleteUser,
  fetchOrgs,
} from "../../actions";

const UserForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const types = [
    { id: "1", name: "현장 관리자" },
    { id: "2", name: "건설사" },
    { id: "3", name: "최고 관리자" },
  ];
  const [type, setType] = useState("3");
  const [OrganizationId, setOrganizationId] = useState("");

  const user = useSelector((state) => state.user.user);
  const organizations = useSelector((state) => state.org.organizations.rows);

  useEffect(() => {
    dispatch(fetchOrgs({}));
    if (id) {
      dispatch(getUser(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (user) {
      console.log("user", user);
      setType(user.type);
      if (parseInt(user.type) !== 3) {
        setOrganizationId(user.Organization.id);
      }
    }
  }, [user]);

  // useEffect(() => {
  //   console.log("OrganizationId", OrganizationId);
  // }, [OrganizationId]);

  useEffect(() => {
    console.log("type", type);
    if (parseInt(type) === 3) {
      setOrganizationId("");
    }
  }, [type]);

  const handleChangeType = (event) => {
    console.log(event.target.value);
    event.preventDefault();
    if (event.target.value) {
      setType(event.target.value);
      setOrganizationId("");
    }
  };

  const handleChangeOrganization = (event) => {
    event.preventDefault();
    setOrganizationId(event.target.value);
  };

  const onSubmit = useCallback(
    (user) => {
      if (parseInt(user.type) === 3 && user.OrganizationId) {
        user.OrganizationId = "";
      }
      if (id) {
        dispatch(updateUser({ user, id }, navigate));
      } else {
        dispatch(submitUser({ user }, navigate));
      }
    },
    [id, dispatch, navigate]
  );

  const onDelete = useCallback(
    (e) => {
      e.preventDefault();
      dispatch(deleteUser({ id }, navigate));
    },
    [id, dispatch, navigate]
  );

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        username: user ? user.username : "",
        name: user ? user.name : "",
        // type: user ? user.type : type,
        // type,
      }}
      validate={(values) => {
        // console.log("values", values);
        const errors = {};
        if (!values.username) {
          errors.username = "필수";
        }
        if (!id && !values.password) {
          errors.password = "필수";
        }
        if (!id && !values.passwordConfirmation) {
          errors.passwordConfirmation = "필수";
        }
        if (
          values.password &&
          values.passwordConfirmation &&
          values.password !== values.passwordConfirmation
        ) {
          errors.passwordConfirmation = "비밀번호가 일치하지 않습니다.";
        }
        if (!values.name) {
          errors.name = "필수";
        }
        if (!values.type) {
          errors.type = "필수";
        }
        if (parseInt(values.type) !== 3 && !values.OrganizationId) {
          errors.OrganizationId = "필수";
        }
        return errors;
      }}
      render={({
        submitError,
        handleSubmit,
        form,
        submitting,
        pristine,
        values,
      }) => (
        <Content>
          <form onSubmit={handleSubmit}>
            <Card>
              <CardContent>
                <Typography variant="h5" component="div">
                  사용자
                </Typography>

                <Grid
                  container
                  alignItems="flex-start"
                  spacing="20"
                  sx={{ mt: 2 }}
                >
                  <Grid item xs={12}>
                    <TextField
                      // required={true}
                      variant="standard"
                      name="username"
                      type="text"
                      label="아이디"
                      disabled={id ? true : false}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      variant="standard"
                      name="password"
                      type="password"
                      label="비밀번호"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="standard"
                      name="passwordConfirmation"
                      type="password"
                      label="비밀번호 확인"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="standard"
                      name="name"
                      type="text"
                      label="이름"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Select
                      name="type"
                      label="권한"
                      variant="standard"
                      data={types}
                      dataKey="id"
                      dataValue="name"
                      onChange={handleChangeType}
                      initialValue={type}
                    />
                  </Grid>

                  {type && parseInt(type) !== 3 && (
                    <Grid item xs={12}>
                      <Select
                        name="OrganizationId"
                        label="건설사"
                        variant="standard"
                        data={organizations}
                        dataKey="id"
                        dataValue="displayName"
                        onChange={handleChangeOrganization}
                        initialValue={OrganizationId}
                      />
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>
            {submitError && <FormHelperText>{submitError}</FormHelperText>}
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={6}>
                {id && (
                  <Button
                    variant="outlined"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={onDelete}
                  >
                    삭제
                  </Button>
                )}
              </Grid>
              <Grid item xs={6} container justifyContent="flex-end">
                <Button
                  variant="contained"
                  endIcon={<SendIcon />}
                  type="submit"
                >
                  저장
                </Button>
              </Grid>
            </Grid>
          </form>
        </Content>
      )}
    />
  );
};

export default UserForm;
